export default __webpack_public_path__ + "static/media/4985.7f45d168.png";